"use strict";

require("core-js/modules/es.array.find.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.function.name.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var StyledIcon = _styledComponents["default"].div.attrs({
  title: function title(props) {
    return props.altText;
  }
}).withConfig({
  displayName: "App__StyledIcon"
})(["height:", ";width:", ";"], function (props) {
  return props.size;
}, function (props) {
  return props.size;
});
var DefaultIcon = function DefaultIcon(props) {
  var color = props.color || '#000000';
  return /*#__PURE__*/_react["default"].createElement("svg", {
    fill: color,
    height: props.size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react["default"].createElement("title", null, props.title || 'Icon Not Found'), /*#__PURE__*/_react["default"].createElement("rect", {
    width: props.size,
    height: props.size
  }));
};
var Icon = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Icon, _Component);
  var _super = _createSuper(Icon);
  function Icon() {
    (0, _classCallCheck2["default"])(this, Icon);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(Icon, [{
    key: "getIconFromContext",
    value: function getIconFromContext() {
      var iconMatch = (0, _lodash.find)(this.context.iconLibrary, {
        name: this.props.name
      });
      if (!iconMatch) {
        return {
          Svg: DefaultIcon,
          altText: 'Icon Not Found'
        };
      }
      return {
        Svg: iconMatch['svg'],
        altText: iconMatch['altText']
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getIconFromCont = this.getIconFromContext(),
        Svg = _this$getIconFromCont.Svg,
        altText = _this$getIconFromCont.altText;
      var size = this.props.size || '100%';
      return /*#__PURE__*/_react["default"].createElement(StyledIcon, (0, _extends2["default"])({
        altText: altText,
        size: size
      }, this.props), /*#__PURE__*/_react["default"].createElement(Svg, (0, _extends2["default"])({
        size: size,
        title: this.props.title || altText
      }, this.props)));
    }
  }]);
  return Icon;
}(_react.Component);
Icon.contextTypes = {
  iconLibrary: _propTypes["default"].array
};
Icon.defaultProps = {
  fill: '#000000'
};
Icon.propTypes = {
  fill: _propTypes["default"].string,
  name: _propTypes["default"].string.isRequired,
  size: _propTypes["default"].string,
  title: _propTypes["default"].string
};
var _default = exports["default"] = Icon;